import { logoutUser } from "../services/authService";
import axiosClient from "./axiosClient";

export const getRequest = async (url, params = {}) => {
  try {
    const response = await axiosClient.get(url, { params });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      logoutUser();
      // window.location.href = "/login";
      return;
    }
    throw error;
  }
};

export const postRequest = async (url, data) => {
  try {
    const response = await axiosClient.post(url, data);
    return response.data;
  } catch (error) {
    console.error("POST Error:", error);
    throw error;
  }
};

export const putRequest = async (url, data) => {
  try {
    const response = await axiosClient.put(url, data);
    return response.data;
  } catch (error) {
    console.error("PUT Error:", error);
    throw error;
  }
};

export const deleteRequest = async (url) => {
  try {
    const response = await axiosClient.delete(url);
    return response.data;
  } catch (error) {
    console.error("DELETE Error:", error);
    throw error;
  }
};

export const patchRequest = async (url, payload = {}) => {
  try {
    const response = await axiosClient.patch(url, payload);
    return response.data;
  } catch (error) {
    console.error("DELETE Error:", error);
    throw error;
  }
};
